import React, { useState, useEffect } from "react";
import { ApiKey, ApiUrl, WebUrl } from "../../util/Constant";
import moment from "moment";
import { useTranslation } from "react-i18next";
import DynamicLoadTable3 from "../../components/custom/DynamicLoadTable3";
import { useHistory } from "react-router-dom";
import Breadcrumb from "components/custom/Breadcrumb";
import RightInformation from "../../components/custom/RightInformation";
import { useDispatch } from "react-redux";
import ApiEngine from "../../util/ApiEngine";
import { setBusy, setIdle } from "../../redux/AppAction";

const InactiveDownlines = () => {
    const { t } = useTranslation();
    const [inactiveUrl, setInactiveUrl] = useState("");
    const [downlineDepositLimit, setDownlineDepositLimit] = useState("");
    const [downlineCount, setDownlineCount] = useState("");
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        getInactiveDownlines();
        getInactiveDownlineLimit();
    }, []);

    const getInactiveDownlines = () => {
        setInactiveUrl(ApiUrl._API_GET_INACTIVE_DOWNLINE_DETAIL);
    };

    const getInactiveDownlineLimit = async () => {
        dispatch(setBusy());
        try {
            const responseJson = await ApiEngine.get(ApiUrl._API_GET_INACTIVE_DOWNLINE_DEPOSIT_LIMIT);
            if (responseJson[ApiKey._API_SUCCESS_KEY]) {
                setDownlineDepositLimit(responseJson[ApiKey._API_DATA_KEY]);
            }
        } catch (error) {
            console.error("Error fetching inactive downline limit:", error);
        } finally {
            dispatch(setIdle());
        }
    };

    const breadcrumb = [
        {
            value: 'DOWNLINE',
            active: false,
            link: WebUrl._URL_DOWNLINE
        },
        {
            value: t("INACTIVE_DOWNLINE_TITLE", { value: downlineDepositLimit }),
            active: true,
            link: WebUrl._URL_INACTIVE_DOWNLINES
        },
    ];

    const headers = [
        { key: 'username', label: t("USERNAME") },
        { key: 'phoneNumber', label: t("PHONE_NUMBER") },
        { key: 'registeredDate', label: t("REGISTERED_DATE") },
        { key: 'deposit', label: t("DEPOSIT") }
    ];

    const renderTableRow = (item, i) => (
        <tr key={`inactive_downline_${i}`}>
            <td className="text-left">{item.username}</td>
            <td className="text-left">{item.phoneNumber}</td>
            <td className="text-left">{moment(item.registeredDate).format("YYYY-MM-DD HH:mm:ss")}</td>
            <td className="text-right">{parseFloat(item.deposit).toFixed(2)}</td>
        </tr>
    );

    return (
        <section className="section-padding">
            <Breadcrumb data={breadcrumb} />
            <div id="inactive-downline">
                <div className="left">
                    <div className="card card-package">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table reportTable">
                                    <DynamicLoadTable3
                                        pageSize={20}
                                        apiQuery={inactiveUrl}
                                        searchEnabled={true}
                                        isTable={true}
                                        headers={headers}
                                        render={renderTableRow}
                                        onComplete={(data) => console.log("Data loaded:", data.totalDataLoaded)}
                                        defaultSortColumn="username"
                                        defaultSortDirection="asc"
                                    />
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="right">
                    <RightInformation
                        newDownlines={true}
                        buttonTwo={true}
                        buttonTwoQuantity={downlineCount}
                        buttonTwoText="DOWNLINE_GROUPS"
                        games={true}
                        promotion={true}
                    />
                </div>
            </div>
        </section>
    );
};

export default InactiveDownlines;